'use strict';

const dedupeLogs = require('./dedupeLogs');

/**
 * @name
 * postLogs
 * @private
 * @description
 * Posts logs to a given route.  On success or failure, fires the callback.
 * @param {string} route
 * @param {array} logs
 * @param {string=} logType
 * @param {object} token
 * @param {string} token.name
 * @param {string} token.value
 * @param {function} callback
 */

function postLogs(route, logs, logType, token, callback) {
    const payload = {};

    if (token.value) {
        payload[token.name] = token.value;
    }

    if (logType !== 'exception') {
        payload.logs = dedupeLogs(logs);
    } else {
        payload.errorLogs = dedupeLogs(logs);
    }

    const xhr = new XMLHttpRequest();
    xhr.open('POST', route, true);
    xhr.setRequestHeader('Content-type', 'application/json');
    if (token.value) {
        xhr.setRequestHeader('X-CSRF-Token', token.value);
    }
    xhr.onerror = function xhrError() {
        return callback(xhr.status);
    };
    xhr.onreadystatechange = function xhrStateChange() {
        if (xhr.readyState === XMLHttpRequest.DONE && xhr.status >= 200 && xhr.status < 400) {
            callback(null);
            return;
        }
        return;
    };
    xhr.send(JSON.stringify(payload));
}

module.exports = postLogs;
